/* eslint-disable import/prefer-default-export */
export class RegistryService {
  /**
   * * Add Item to Registry
   * @param {AddToRegistryPayload} payload - The payload object.
   *
   * TODO Add typings for payload when implemented
   */
  async addItem(payload) { // eslint-disable-line no-unused-vars
    // Add to registry logic should be here
  }
}
